import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-company-detail-card',
    templateUrl: './company-detail-card.component.html',
    styleUrls: ['./company-detail-card.component.scss'],
    standalone: false
})
export class CompanyDetailCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
